// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1175":"PrototypeViewer","1628":"livekit-egress-template"}[chunkId] || chunkId) + "." + {"1175":"19a267c8bc0938cd17e7","1217":"ad2caa887b54899a04ba","1628":"8405db1cf821eeeb236d","2054":"19a267c8bc0938cd17e7","2738":"d1ff44c9b7f2ae2a8b63","5182":"00f6a40d45514ae361fa"}[chunkId] + ".chunk.css";
};